import React from 'react';
import { useEffect, useState } from 'react';
import { format } from 'date-fns';
import { useAppContext } from '../../../../Services/AppContext';
import QuestionnaireResultTableItem from '../../../../Components/Questionnaire/QuestionnaireResultTableItem';
import HealthDataBaseTable from './HealthDataBaseTable';
import useTable from '../../Hooks/useTable';
import { HealthDataFilterFormValues } from '../Filter/HealthDataFilterForm';
import { HealthDataTableColumn } from '../../Utils/tableColumns';
import useTranslation from '../../../../Hooks/useTranslation';
import { GLUCOSE_CUSTOM_ORDERING } from '../../Utils/healthDataSettings';

export interface HealthDataBloodGlucoseTableProps {
	healthData: any;
	isLoading: boolean;
	filter: HealthDataFilterFormValues;
}

const HealthDataBloodGlucoseTable: React.FC<
	HealthDataBloodGlucoseTableProps
> = props => {
	const { healthData, isLoading, filter } = props;
	const [data, setData] = useState<any[]>([]);
	const { translation } = useAppContext();
	const { t } = useTranslation();
	const { getTextColor, getBackgroundColor, getTimeByView } = useTable();

	console.log('healthData', healthData);

	const columns = [
		{
			key: 'date',
			title: t('base.shared.date'),
			renderItem: (item: { date: string }) => {
				return (
					<QuestionnaireResultTableItem
						value={item.date}
						color={'#ffffff'}
						textColor={'#000000'}
					/>
				);
			},
		},
		{
			key: 'time',
			title: t('base.shared.time'),
			renderItem: (item: { time: HealthDataTableColumn }) => {
				return (
					<QuestionnaireResultTableItem
						value={item.time.value}
						color={item.time.color}
						textColor={item.time.textColor}
					/>
				);
			},
		},
		{
			key: 'questionnaireCode',
			title: t('base.shared.questionnaire'),
			renderItem: (item: { questionnaireCode: HealthDataTableColumn }) => {
				return (
					<QuestionnaireResultTableItem
						value={item.questionnaireCode.value}
						color={item.questionnaireCode.color}
						textColor={item.questionnaireCode.textColor}
					/>
				);
			},
		},
		{
			key: 'value',
			title: t('base.glycemia'),
			renderItem: (item: { value: HealthDataTableColumn }) => {
				return (
					<QuestionnaireResultTableItem
						value={item.value.value}
						color={item.value.color}
						source={item.value.source}
						textColor={item.value.textColor}
					/>
				);
			},
		},
	];

	useEffect(() => {
		const tempData: any[] = [];

		if (healthData) {
			for (const row of GLUCOSE_CUSTOM_ORDERING) {
				const type = healthData.find((item: any) => item.key === row);
				if (type) {
					let date: any = null;
					type.data.map((row: any, index: number) => {
						const value = Math.round(parseFloat(row.value));
						let formattedDate = format(
							row.time.toDate(),
							translation['base.dateFormatJsReact'],
						);
						let useDate = '';
						if (date !== formattedDate) {
							if (value != 0) {
								date = formattedDate;
							}
							useDate = formattedDate;
						}
						let newRow: any = {
							id: `${index}`,
							date: useDate,
							time: {
								value: getTimeByView(filter.view, row.time, false, filter.type),
								color: 'rgb(250,250,252)',
								textColor: '#000',
							},
							questionnaireCode: {
								value: type.description,
								color: 'rgb(250,250,252)',
								textColor: '#000',
							},
							value: {
								value:
									value != 0 ? parseFloat(row.value) + ' ' + type.unit : '-',
								color:
									value != 0
										? getBackgroundColor(type.key, 'bloodGlucose', value)
										: 'rgb(250,250,252)',
								textColor:
									value != 0
										? getTextColor(type.key, 'bloodGlucose', value)
										: '#000',
								source: row.questionnaire?.title ?? row.source?.title ?? null,
							},
						};
						if (value != 0) {
							newRow['show'] = true;
						}
						tempData.push(newRow);
					});
				}
			}
		}

		setData(tempData);
	}, [healthData]);

	return (
		<HealthDataBaseTable
			title='base.glycemia'
			rows={data}
			columns={columns}
			isLoading={isLoading}
		/>
	);
};

export default HealthDataBloodGlucoseTable;
